export enum StatusItemResponsibility {
  Depot = 1,
  Dispatcher = 2,
}

export enum StatusItemIssueSeverity {
  // None = 0,
  // Low = 1,
  Medium = 2,
  High = 3,
}

export enum StatusItemIssueType {
  DriverNotSignedIn = 1,
  APC = 2,
  DPI = 3,
  VehicleAssigned = 4,
  LowTemperature = 5,
  NoTemperatureData = 6,
  AllocationMismatch = 7,
  FaultAlarm = 8,
  NoMessages = 9,
  ChargerConnected = 10,
}

/**
 * Mirrors HealthCheckIssueReason in connect-bus-api (written by connect-bus-rtp).
 * Identifies the message template for a status item issue's detailed description;
 * placeholders are filled from the issue's `parameters`.
 * Do not reorder or reuse values; backend only appends new ones.
 */
export enum HealthCheckIssueReason {
  Unknown = 0,
  DriverNotSignedInNoData = 1,
  DriverNotSignedInLastMessage = 2,
  VehicleNotAssigned = 3,
  LowTemperatureDataMissing = 4,
  LowTemperatureBelowThreshold = 5,
  AllocationMismatchVehicleNotInIvu = 6,
  AllocationMismatchVehicleOverridden = 7,
  AllocationMismatchNoAllocation = 8,
  VehicleNotSendingEvents = 9,
  ChargerConnectedPreDeparture = 10,
  FaultAlarmFreeText = 11,
}

export enum StatusItemIssueTypeString {
  DriverNotSignedIn = 'driver_not_signed_in',
  APC = 'apc',
  DPI = 'dpi',
  VehicleAssigned = 'vehicle_assigned',
  LowTemperature = 'low_temperature',
  NoTemperatureData = 'no_temperature_data',
  AllocationMismatch = 'allocation_mismatch',
  FaultAlarm = 'fault_alarm',
  NoMessages = 'no_messages',
  ChargerConnected = 'charger_connected',
}
